<template>
  <section class="articles" ref="articles">
    <slot></slot>
    <AccesskeyLink
      id="mainContent"
      class="accesskey-c"
      accesskey="C"
      title=":::主要內容顯示區"
    />
    <!-- 圖鑑集列表 -->
    <AlbumCollection
      class="albums__layout"
      :coverings="articles"
      :displayType="displayType"
      v-if="linkPath === 'albums' && displayType == 'album'"
    >
      <template v-slot:title="album">
        <!-- 銜接相簿的標題，album 是 slotProp -->
        <h4>{{ album.cover.title }}</h4>
      </template>
    </AlbumCollection>
    <!-- 單本圖鑑集的照片列表 -->
    <PhotoCollection
      class="albums__layout albums__layout--photo"
      :albumPhotos="articles"
      :displayType="displayType"
      v-else-if="linkPath == 'album' && displayType == 'album'"
    />
    <!-- 卡片 -->
    <HeroCards
      :cards="articles"
      :linkPath="linkPath"
      :isList="true"
      v-else-if="displayType == 'card' && !isFestivalYear"
    />
    <WhiteCards
      v-if="isFestivalYear"
      :cards="articles"
      :routerTo="{ name: linkPath }"
      :isList="true"
      :hasCategory="hasCategory"
    />
    <PreparationMessage v-if="isFestivalYear && !articles.length" />
    <p class="articles__no-data" v-if="articles.length === 0">目前沒有文章</p>
  </section>
</template>

<script>
// import { lazyloading } from '@/utils/lazyloading';

import HeroCards from "@/components/HeroCards";
import WhiteCards from "@/components/WhiteCards";
import AlbumCollection from "@/components/AlbumCollection";
import PhotoCollection from "@/components/PhotoCollection";
import PreparationMessage from "@/components/PreparationMessage";
import AccesskeyLink from "@/components/a11y/AccesskeyLink.vue";

export default {
  name: "TheArticleList",
  props: {
    articles: {
      type: [Array, Object],
      default: () => [],
    },
    linkPath: {
      type: String,
      default: "",
    },
    hasCategory: {
      type: Boolean,
      default: true,
    },
    displayType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    isFestivalYear() {
      return this.$route.meta.isRenderingFestivalTheme;
    },
  },
  updated() {
    // const oldLoadedElemet = this.$refs.articles.querySelectorAll('.loaded');
    // 當列表更新時，將圖片再懶載入一次
    // if (oldLoadedElemet.length) {
    //   oldLoadedElemet.forEach(el => {
    //     el.classList.remove('loaded');
    //     el.classList.add('lazyload');
    //   });
    // lazyloading();
    // }
  },
  methods: {},
  components: {
    HeroCards,
    WhiteCards,
    AlbumCollection,
    PhotoCollection,
    PreparationMessage,
    AccesskeyLink,
  },
};
</script>

<style lang="scss" scoped>
.articles {
  > p {
    font-size: 1.25rem;
    text-align: center;
  }

  h4 {
    font-size: 1.375rem;
    margin: 0 auto 40px;
    color: $color-light-title;
    letter-spacing: 1.22px;
    line-height: 2;
    @include truncate-string(280px);
  }

  .title {
    margin: 50px 0 30px;

    @include for-tablet {
      margin-top: 60px;
    }

    @include for-desktop {
      margin-top: 80px;
    }
  }
  &__no-data {
    text-align: center;
    font-size: 1.5rem;
    font-family: $text-font-family;
    color: $color-light-title;
  }
}

.albums {
  /* 圖鑑集列表 */
  &__layout {
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;

    @include for-tablet {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: flex-start;
      max-width: 605px;
    }

    @include for-desktop {
      max-width: 930px;
      justify-content: flex-start;
    }

    &--photo {
      @include for-desktop {
        max-width: 860px;
      }
    }
  }
}
</style>
